import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { SharedMenus } from '@shared/menus';
import { MenuItemModel } from '@shared/models/menu.model';

@Component({
  selector: 'app-shared-menu',
  templateUrl: './shared-menu.component.html',
  styleUrls: ['./shared-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedMenuComponent implements OnInit {
  @Input() options: { class?: string, aside?: string };

  sharedMenus: MenuItemModel[] = SharedMenus;
  constructor() {}

  ngOnInit(): void {}
}
